import { createAction, props } from '@ngrx/store';
import { ILogin, ILoginResponse, IUserResponse } from '../../interfaces/auth.interface';

export const authLogin = createAction(
  '[Auth] Login',
  props<{login: ILogin}>()
);

export const authLoginSuccess = createAction(
  '[Auth] Get Login Success',
  props<{response: ILoginResponse}>()
);

export const getUser = createAction(
  '[Auth] Get User',
);

export const getUserSuccess = createAction(
  '[Auth] Get User Success',
  props<{response: IUserResponse}>()
);
